<div class="post-memory-container dialog-container">
    <h3 style="text-align: center; margin-bottom: 10px;">Dopasuj słowa i ilustracje</h3>
    <div class="memory-board">
        <div
            class="memory-tile"
            (click)="openTile(tile)"
            *ngFor="let tile of tiles"> 
            <div class="memory-tile-open"
                [style.display]="displayTile(tile)"
                [style.backgroundImage]="'url('+tile.tile+')'"></div>    
        </div>
    </div>
    <div *ngIf="showDialog();" 
        class="answer-dialog">
        <div class="close-button"
            (click)="closeDialog();">
            x
        </div>
        <div *ngIf="showDialogOk" class="correct">
            <h1>Juuhuuu!</h1>
            <p>Wszystkie pary znalezione!</p>
        </div>    
        <button *ngIf="post.next" 
            class="lite"
            [routerLink]="['/task', post.next]">
            Odkrywaj dalej!
        </button>
        <button *ngIf="!post.next" 
            class="lite"
            routerLink="/categories">
            Powrót do kategorii
        </button>
    </div>
</div>